export const parseUrl = (url: string | null) => {
  try {
    return url ? new URL(url) : undefined;
  } catch {
    return undefined;
  }
};
